<template>
  <div class="dashboard-card">
    <div class="dashboard-card__title">Ocupacion de mesas</div>

    <div class="occupation-grid">
      <div class="occupation-item">
        <div class="occupation-item__label">Total de mesas</div>
        <div class="occupation-item__value">{{ data.totalTables }}</div>
      </div>

      <div class="occupation-item">
        <div class="occupation-item__label">Mesas completas</div>
        <div class="occupation-item__value">{{ data.fullTables }}</div>
      </div>

      <div class="occupation-item">
        <div class="occupation-item__label">Mesas con lugares disponibles</div>
        <div class="occupation-item__value">{{ data.tablesWithAvailability }}</div>
      </div>

      <div class="occupation-item">
        <div class="occupation-item__label">Invitados sin asignar</div>
        <div class="occupation-item__value">{{ data.unassignedGuests }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import occupationService from '@/services/dashboard/table_occupation_dashboard'

export default {
  name: 'TableOccupationCard',
  props: {
    eventId: { type: [String, Number], required: true },
    refreshToken: { type: Number, default: 0 }
  },
  data() {
    return {
      data: {
        totalTables: 0,
        fullTables: 0,
        tablesWithAvailability: 0,
        unassignedGuests: 0
      }
    }
  },
  watch: {
    eventId: {
      immediate: true,
      handler() {
        this.loadCard()
      }
    },
    refreshToken() {
      this.loadCard()
    }
  },
  methods: {
    async loadCard() {
      this.data = await occupationService.get(this.eventId)
    }
  }
}
</script>

<style scoped>
.dashboard-card {
  height: 100%;
  padding: 16px;
  border-radius: 12px;
  border: 1px solid #dfe7df;
  background: #fff;
  box-shadow: 0 4px 14px rgba(31, 41, 55, 0.08);
}

.dashboard-card__title {
  font-size: 15px;
  font-weight: 700;
  color: #374151;
  margin-bottom: 12px;
}

.occupation-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
}

.occupation-item {
  border: 1px solid #e5ece5;
  border-radius: 10px;
  padding: 10px;
  background: #f8fbf8;
}

.occupation-item__label {
  font-size: 12px;
  color: #6b7280;
  min-height: 32px;
}

.occupation-item__value {
  margin-top: 4px;
  font-size: 22px;
  font-weight: 700;
  color: #1f2937;
}

@media (max-width: 767px) {
  .occupation-grid {
    grid-template-columns: 1fr;
  }
}
</style>
